import React from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  VStack,
  HStack,
  Text,
  Button,
  Box,
  Badge,
  Divider,
  useColorModeValue,
} from '@chakra-ui/react';
import { FiStar, FiTrendingUp, FiSettings } from 'react-icons/fi';

const UpgradeModal = ({ 
  isOpen, 
  onClose, 
  restrictionType, 
  restrictionMessage, 
  currentPlan,
  onUpgrade 
}) => {
  const cardBg = useColorModeValue('white', 'gray.800');
  const borderColor = useColorModeValue('gray.200', 'gray.700');

  const getRestrictionTitle = () => {
    switch (restrictionType) {
      case 'feature_access':
        return 'Feature Access Restricted';
      case 'employee_limit':
        return 'Employee Limit Reached';
      default:
        return 'Upgrade Required';
    }
  };

  const getCurrentPlanDisplay = () => {
    if (!currentPlan || currentPlan === 'Unknown') {
      return 'Free Plan';
    }
    return currentPlan;
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="md">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>
          <HStack spacing={3}>
            <FiStar color="gold" />
            <Text>{getRestrictionTitle()}</Text>
          </HStack>
        </ModalHeader>
        <ModalCloseButton />
        
        <ModalBody pb={6}>
          <VStack spacing={6} align="stretch">
            {/* Current Plan Info */}
            <Box p={4} bg="blue.50" borderRadius="md" border="1px solid" borderColor="blue.200">
              <VStack spacing={2} align="start">
                <Text fontSize="sm" color="blue.800" fontWeight="medium">
                  Current Plan
                </Text>
                <HStack spacing={2}>
                  <Badge colorScheme="blue" variant="subtle">
                    {getCurrentPlanDisplay()}
                  </Badge>
                </HStack>
              </VStack>
            </Box>

            {/* Restriction Message */}
            <Box>
              <Text color="gray.700" fontSize="md" lineHeight="tall">
                {restrictionMessage || 'This feature requires a higher plan tier.'}
              </Text>
            </Box>

            <Divider />

            {/* Action Buttons */}
            <VStack spacing={3}>
              <Button
                colorScheme="blue"
                size="lg"
                w="full"
                onClick={onUpgrade}
                leftIcon={<FiTrendingUp />}
              >
                Upgrade Plan
              </Button>
              
              <Button
                variant="ghost"
                onClick={onClose}
                size="sm"
              >
                Maybe Later
              </Button>
            </VStack>
          </VStack>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default UpgradeModal; 